import { cookiePrefix } from "../index";
export class Cookies {
    static deleteCookie(name) {
        name = cookiePrefix + name;
        document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
    /*
    public static createSessionCookie(
        sessionCookieName: string,
        domainUUID: string,
        userIdentity: Nullable<string> = null,
        arbitaryData: Nullable<any> = null
    ): Promise<any> {
        
        let data: any = {};
        
        let sessionId: Nullable<string> = Cookies.getCookie(sessionCookieName);
        data['referrer'] = document.referrer;
        data['current_url'] = document.location.href;
        data['domain_uuid'] = domainUUID;
        if (userIdentity) data['user_identity'] =  userIdentity;
        if (arbitaryData) data['arbitrary_data'] = arbitaryData;
        if (sessionId) data['session_id'] = sessionId;

        Logger.verbose("Going to create session");

        return new Promise((resolve, reject) => {
            XHR.call(DataTrackingClient.getInstance().apiHost + '/api/track/session', "POST", data).then(
                (xhr: XMLHttpRequest) => {
                    let res: any;
                    try {
                        res = JSON.parse(xhr.responseText);
                    } catch {
                        Logger.error("Response is not a valid JSON")
                        reject(new Error("Response is not a valid JSON"));
                    }
                    if (res.success) {
                        Logger.debug("Session cookie created => " + sessionCookieName + " => " + res.data);
                        var expiry_date = new Date();
                        let cookie_days = (3 * 24 * 60 * 60 * 1000) ; //(15 * 60 * 1000);
                        expiry_date.setTime(expiry_date.getTime() + cookie_days);
                        Cookies.createCookie(sessionCookieName, res.data, expiry_date);
                        resolve(res);
                    } else {
                        Logger.error("Failed to create session");
                        reject(res);
                    }
                },
                (err: any) => {
                    Logger.error("Failed to create session");
                    reject(err);
                }
            );
        });
    }
    */
    static createCookie(name, value, expiry = null) {
        name = cookiePrefix + name;
        let cookieString = name + '=' + value + "; Path=/; SameSite=lax; Expires=";
        if (expiry) {
            cookieString += expiry.toUTCString();
        }
        else {
            cookieString += "0";
        }
        document.cookie = cookieString;
    }
    static getCookie(name, includePrefix = true) {
        //  while (c.charAt(0) == ' ') c = c.substring(1, c.length);  !!!!!!!!!
        if (includePrefix)
            name = cookiePrefix + name;
        const nameLenPlus = (name.length + 1);
        return document.cookie
            .split(';')
            .map(c => c.trim())
            .filter(cookie => {
            return cookie.substring(0, nameLenPlus) === `${name}=`;
        })
            .map(cookie => {
            return decodeURIComponent(cookie.substring(nameLenPlus));
        })[0] || null;
    }
}
